import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface ICommentList {
    comments_count?: number
    content: string
    created_at: number
    id: string
    is_liked?: boolean
    likes_count?: number
    parent_id?: string
    parent_type?: string
    user?: {id: string; name: string; thumbnail: string; is_filtered?: boolean}
    user_id?: string
}

export const getCommentList = async (
    size: number,
    current_page: number = 1,
    search_word: string = '',
    search_id: string = '',
): Promise<ApiRes<ICommentList[]>> => {
    return await apiGet(
        API_URL,
        `admin/comments?page_size=${size}&current_page=${current_page}&content=${search_word}&search_id=${search_id}`,
    )
}
